import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { AiFillHome } from "react-icons/ai"; // Import Home Icon
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import AboutUs from "./pages/AboutUs";
import Admin from "./pages/Admin";
import OurPlans from "./pages/OurPlans";
import Register from "./pages/Register";
import FloatingWhatsApp from "./components/FloatinWhatsapp";
import Dashboard from "./pages/Dashboard";
import Subscribe from "./pages/Subscribe";
import { motion } from "motion/react";
import Withdraw from "./pages/Withdraw";

function HomeButton() {
  const location = useLocation();
  const navigate = useNavigate();

  // Define pages where the navbar is hidden
  const hideNavAndFooter = [
    "/login",
    "/register",
    "/dashboard",
    "/subscribe",
    "/withdraw", // Assuming you have a withdraw page
  ].includes(location.pathname);

  // Do not show the Home Button on Dashboard
  if (!hideNavAndFooter || location.pathname === "/dashboard") return null;

  // Determine where the button should navigate to
  const goTo = ["/subscribe", "/withdraw"].includes(location.pathname)
    ? "/dashboard"
    : "/";

  return (
    <div
      className="fixed bottom-5 left-5 bg-secondary-500 text-white p-3 rounded-full shadow-lg cursor-pointer flex items-center justify-center"
      onClick={() => navigate(goTo)}
    >
      <AiFillHome size={30} />
    </div>
  );
}

function App() {
  const location = useLocation();

  // Pages where Navbar and Footer should be hidden
  const hideNavAndFooter = [
    "/login",
    "/register",
    "/dashboard",
    "/subscribe",
    "/withdraw",
  ].includes(location.pathname);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1.3 }}
    >
      {!hideNavAndFooter && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/plans" element={<OurPlans />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/withdraw" element={<Withdraw />} />
      </Routes>
      {!hideNavAndFooter && <Footer />}
      <FloatingWhatsApp />
      <HomeButton />
    </motion.div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
